var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{style:({ backgroundColor: _vm.getPageBackgroundColor }),attrs:{"fluid":""}},[_c('SlicesBlock',{attrs:{"slices":_vm.slices}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }